import { VStack } from "@chakra-ui/react"
import React from "react"
import { UpdatePhoneDeviceForm } from "../../forms"

export type UpdatePhoneDeviceProps = {
	phoneDeviceId: string
}

export const UpdatePhoneDevice: React.FC<UpdatePhoneDeviceProps> = ({ phoneDeviceId }) => {
	return (
		<VStack w="full" maxW="sm" spacing={6}>
			<UpdatePhoneDeviceForm phoneDeviceId={phoneDeviceId} />
		</VStack>
	)
}
